import React, { useState } from 'react';
import {
  Grid,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  CircularProgress,
  Box
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useNavigate } from 'react-router-dom';
import { RegisterUsabilityLog } from '../../../shared/data-services/ModuleUsabilityLog-service';
import { GpsFixed, GpsFixedSharp, GpsNotFixed, GpsOffTwoTone } from '@mui/icons-material';

const ContentSai = ({ user }) => {
  const name = user.name;
  const navigate = useNavigate();
  const [openZonesModal, setOpenZonesModal] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);




  const handleOpenZonesModal = async () => {
    await RegisterUsabilityLog('Zonas en BOG', user.employeeId);
    setImageLoading(true);
    setOpenZonesModal(true);
  };

  const handleCloseZonesModal = () => {
    setOpenZonesModal(false);
  };

  const handleQuickAccess = async (route, logText) => {
    await RegisterUsabilityLog(logText, user.employeeId);
    navigate(route);
  };


  const handleDownload = async () => {
  setIsDownloading(true);
  await RegisterUsabilityLog('Zonas en BOG-Descargar', user.employeeId);
  const link = document.createElement('a');
  link.href = './Images/Descargar_Zonas.jpg';
  link.download = 'ZonasBOG.jpg';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => {
    setIsDownloading(false);
  }, 1500);
};


 return (
  <>
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="h5" style={{ color: '#8ebb37' }} fontWeight="bold" sx={{ m: 1 }}>
              <b>Hola {name}!</b>
            </Typography>
            <Typography variant="h5" style={{ color: '#1a3072' }} fontWeight="bold" sx={{ m: 1 }}>
              <i>Bienvenido a Tu experiencia <span style={{ color: '#00b0ef' }}><b>Talma</b></span></i>
            </Typography>
          </Grid>

          <Grid item xs={12} style={{ marginBottom: 20 }}>
            <iframe
              width="100%"
              height="415"
              src="https://www.youtube.com/embed/muy1rjjA21A"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </Grid>

          {/* Botones de acceso rápido */}
          <Grid item xs={12}>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              {/* Mis Turnos */}
              <Grid item xs={6} sm={4} md={3}>
                <Card sx={{ maxWidth: 200, mx: "auto", backgroundColor: "#00000008" }}>
                  <CardActionArea onClick={() => handleQuickAccess('/ShiftCalendar', 'Mis Turnos - Autogestión')} sx={{ textAlign: "center" }}>
                    <CalendarMonthIcon sx={{ fontSize: 60, color: "#27b9d4" }} />
                    <CardContent sx={{ p: 0 }}>
                      <Typography variant="h6" sx={{ color: "#8ebb37", fontWeight: "bold", m: 0 }}>
                        Consulta de
                      </Typography>
                      <Typography variant="h6" sx={{ color: "#1a3072", fontWeight: "bold" }}>
                        Mis Turnos
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>

              {/* Zonas en BOG */}
              {/* <Grid item xs={6} sm={4} md={3}>
                <Card sx={{ maxWidth: 200, mx: "auto", backgroundColor: "#00000008" }}>
                  <CardActionArea onClick={handleOpenZonesModal} sx={{ textAlign: "center" }}>
                    <GpsFixedSharp sx={{ fontSize: 60, color: "#27b9d4" }} />
                    <CardContent sx={{ p: 0 }}>
                      <Typography variant="h6" sx={{ color: "#8ebb37", fontWeight: "bold", m: 0 }}>
                        Conoce las
                      </Typography>
                      <Typography variant="h6" sx={{ color: "#1a3072", fontWeight: "bold" }}>
                        Zonas en BOG
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} md={6}>
        <img src="./Images/hom_tu_experiencia.jpg" alt="logo" style={{ width: '100%', height: '90%' }} />
      </Grid>
    </Grid>

    {/* Modal con la imagen de zonas */}
    <Dialog open={openZonesModal} onClose={handleCloseZonesModal} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Zonas en BOG
        <IconButton onClick={handleCloseZonesModal}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

    <DialogContent sx={{ textAlign: 'center' }}>
      {imageLoading && (
        <div style={{ marginBottom: 16 }}>
          <Typography variant="body1" sx={{ mb: 1 }}>Cargando imagen...</Typography>
          <CircularProgress />
        </div>
      )}

      <img
        src="./Images/Comunicado_Zonas.jpg"
        alt="Zonas en BOG"
        onLoad={() => setImageLoading(false)}
        style={{
          width: '100%',
          height: 'auto',
          marginBottom: 16,
          opacity: imageLoading ? 0 : 1,
          transition: 'opacity 0.5s ease-in-out'
        }}
      />


     {!imageLoading && (
  <>
    {!imageLoading && (
      <Box display="flex" justifyContent="center">
        <button
          onClick={handleDownload}
          disabled={isDownloading}
          style={{
            padding: '10px 20px',
            backgroundColor: isDownloading ? '#8a8a8a' : '#1a3072',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: isDownloading ? 'not-allowed' : 'pointer',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            minWidth: '150px'
          }}
        >
          Descargar
          {isDownloading && (
            <CircularProgress size={20} sx={{ color: 'white' }} />
          )}
        </button>
      </Box>

          )}
        </>
      )}
    </DialogContent>
    </Dialog>
  </>
);


};

export default ContentSai;
